import { useNavigate } from "react-router-dom";
import { useRecordListContext } from "./useRecordListContext";
import useNotification from "component/global/event-handler/hooks/use-notification";
import useCodeScriptFunctionInput from "component/global/generic-hooks/use-code-script-fn-api";
import { emitRecordMutation } from "shared/services/recordMutationBus";
import { executeRecordListScript } from "../services/executeRecordListScript";
import SysRecord from "app/class/record";

export const useRecordListRelatedActionCompiler = () => {

    const { api } = useCodeScriptFunctionInput();
    const notifyApi = useNotification();
    const navigate = useNavigate();
    const { selectedRows, table } = useRecordListContext();

    const actionContext = {
        ...api,
        ...notifyApi,
        navigate
    };

    const runActionScript = async (action: SysRecord) => {
        try {
            const result = await executeRecordListScript(
                action.script,
                actionContext,
                selectedRows,
                table,
                "related_list",
                action.timeout_ms
            );

            if (table?.name && !result.mutatedTables.length) {
                emitRecordMutation({
                    table: table.name,
                    source: "record_related_list_action",
                });
            }
        } catch (error: any) {
            notifyApi.alert(
                "LIST-ACTION-ERROR",
                error?.message || "Error executing list action"
            );
            console.error("RecordListActionError:", error);
        }
    };

    return { runActionScript };
};
